/**
 * In-app notifications (the header bell). One row per person per web-push fan-out, written by
 * the API alongside the push itself, so the bell lists everything the system ever told this user
 * — assignments, mentions, leave events, company announcements — read or not.
 */
/**
 * Where a row came from. Set server-side by the producer, never by a client. Plain strings in
 * the database so a new source needs no migration.
 */
export const NOTIFICATION_KINDS = ['issue', 'doc', 'leave', 'event', 'product', 'handbook', 'announce', 'system', 'okr', 'game', 'ua'];
export function isNotificationKind(v) {
    return typeof v === 'string' && NOTIFICATION_KINDS.includes(v);
}
export const NOTIFICATION_LIST_LIMIT = 50;
/** In-app body cap: the popup is one readable column, and the list ships 50 full rows a minute. */
export const NOTIFICATION_BODY_MAX = 2000;
export const NOTIFICATION_TITLE_MAX = 120;
/** What the phone banner gets when the inbox keeps a longer text (company events, announcements). */
export const NOTIFICATION_PUSH_BODY_MAX = 200;
/** Rows older than this are purged nightly, read or not. */
export const NOTIFICATION_RETENTION_DAYS = 90;
//# sourceMappingURL=notifications.contract.js.map